import styled from "styled-components";

export const MainContainer = styled.div`
  flex-direction: row;
  background: transparent;
  min-height: 100vh;
  display: flex;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
`;
export const ItemContainer = styled.div`
  display: flex;

  flex-direction: row;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  padding-bottom: 40px;
`;
